<template>
  <div class="con-present" v-if="lecture.topic && Number(lecture.topic.typeid) === 3">
    <div class="con-present-header display-mobile">
      <h2>{{lecture.title}}</h2>
      <template v-if="lecture.topic">
        <router-link :to="'/track/' + lecture.topic.id">
          <h3 class="belongsto">所属专题：{{lecture.topic.topic}}</h3>
        </router-link>
      </template>
      <h3 class="guest">嘉宾 : {{lecture.speaker.name}} | {{lecture.speaker.company}}{{lecture.speaker.position}}</h3>
      <h3 class="time" v-if="$store.state.info.displayPresentationTime"><span>时间 : {{presentationTime}}</span></h3>
      <h3 class="location" v-if="lecture.address"><span>会议室 : {{lecture.address}}</span></h3>
      <a v-if="lecture.pptLink" :href="lecture.pptLink" target="_blank" class="ppt"><i class="iconfont icon-ppt"></i></a>
    </div>
    <h1 class="title display-mobile">讲师介绍</h1>
    <template v-if="lecture.speakerIds && lecture.speakerIds.length!==0">
      <speaker
        :speaker-config="speakerConfig"
        :speaker="speakers[sid]"
        :lecture="$store.state.lectures[id]" v-for="(sid, idx) in lecture.speakerIds" :key="idx"></speaker>
    </template>
    <h1 class="title display-mobile">培训介绍</h1>
    <section class="con-present-info">
      <div class="container">
        <div class="left">
          <h5 v-if="lecture.beginTime && $store.state.info.displayPresentationTime">
            <i class="iconfont icon-time"></i>时间：{{presentationTime}}
          </h5>
          <h5 v-if="lecture.address">
            <i class="iconfont icon-location"></i>地点：{{lecture.address}}
          </h5>
          <h5 v-if="lecture.topic">
            <i class="iconfont icon-track"></i>
            <template v-if="lecture.topic">
              <router-link :to="'/track/' + lecture.topic.id">所属专题：{{lecture.topic.topic}}</router-link>
            </template>
          </h5>
        </div>
        <div class="right">
          <h1>
            <span>{{lecture.title}}</span>
          </h1>
          <div class="content" v-html="lecture.introduce">
          </div>
        </div>
      </div>
    </section>

    <section class="con-present-relate display-pc" v-if="relativeData.length && Number(id)!=181 && Number(id)!=182">
      <div class="container">
        <h2>相关培训</h2>
        <ul class="columns is-multiline">
          <li class="column is-one-third" v-for="(lecture, index) in relativeData" :key="index">
            <router-link class="present" :to="'/training/' + lecture.id" :class="lecture.speakerIds.length>2?'multi':''" v-if="Number($store.state.topics[lecture.topicId].typeid)===3">
              <div class="title">{{lecture.title}}</div>
              <div class="relative-bottom" :class="lecture.speakerIds.length>1?'multi':''">
                <div class="bottom" v-for="(sid, idx) in lecture.speakerIds" :key="idx" v-if="speakers[sid]">
                  <img :src="speakers[sid].avatar">
                  <div class="detail">
                    <h4>{{speakers[sid].name}}</h4>
                    <h6>{{speakers[sid].company}}</h6>
                    <h6 class="position">{{speakers[sid].position}}</h6>
                  </div>
                </div>
              </div>
            </router-link>
            <router-link class="present" :to="'/presentation/' + lecture.id" :class="lecture.speakerIds.length>2?'multi':''" v-if="Number($store.state.topics[lecture.topicId].typeid)===0">
              <div class="title">{{lecture.title}}</div>
              <div class="relative-bottom" :class="lecture.speakerIds.length>1?'multi':''">
                <div class="bottom" v-for="(sid, idx) in lecture.speakerIds" :key="idx" v-if="speakers[sid]">
                  <img :src="speakers[sid].avatar">
                  <div class="detail">
                    <h4>{{speakers[sid].name}}</h4>
                    <h6>{{speakers[sid].company}}</h6>
                    <h6 class="position">{{speakers[sid].position}}</h6>
                  </div>
                </div>
              </div>
            </router-link>
            <router-link class="present" :to="'/track/' + lecture.id" :class="lecture.speakerIds.length>2?'multi':''" v-if="Number($store.state.topics[lecture.topicId].typeid)===1">
              <div class="title">{{lecture.title}}</div>
              <div class="relative-bottom" :class="lecture.speakerIds.length>1?'multi':''">
                <div class="bottom" v-for="(sid, idx) in lecture.speakerIds" :key="idx" v-if="speakers[sid]">
                  <img :src="speakers[sid].avatar">
                  <div class="detail">
                    <h4>{{speakers[sid].name}}</h4>
                    <h6>{{speakers[sid].company}}</h6>
                    <h6 class="position">{{speakers[sid].position}}</h6>
                  </div>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import Speaker from '../com-speaker'
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  components: {
    Speaker
  },
  props: [
    'id'
  ],
  computed: {
    lecture () {
      return this.$store.state.lectures[this.id] || {
        speaker: {},
        relativeLectureIds: [],
        speakerIds: [],
        relativeManualLectureIds: []
      }
    },
    speakers () {
      return this.$store.state.speakers
    },
    relativeData () {
      return this.lecture.relativeLectureIds.map(id => this.$store.state.lectures[id]).concat(this.lecture.relativeManualLectureIds.map(id => this.$store.state.lectures[id]))
    },
    speakerConfig () {
      return this.$store.state.speakerConfig
    },
    presentationTime () {
      return moment(this.lecture.beginTime).utcOffset('+08:00').format('MM月DD日 hh:mm')
    }
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
.con-present > .title
  // background-color: #2180c2
  background-color: var(--primary-color)
  height: 45px
  line-height: 45px
  font-size: 18px
  color: #fff
  text-align: center

.con-present-info
  background-color: #fff
  padding: 100px 0
  +mobile
    padding: 30px 0
  .container
    display: flex
    justify-content: space-between
    align-items: center
    +mobile
      display: block
  .left
    width: 345px
    padding-right: 30px
    flex-shrink: 0
    +tablet
      padding-left: 30px
    +mobile
      display: none
    h5
      color: #8e9ca9
      font-size: 16px
      line-height: 1.8
      margin-top: 9px
      display: flex
      align-items: center
      // justify-content: flex-end
      i.iconfont
        margin-right: 8px
        color: var(--primary-color)
      a
        color: inherit
        &:hover
          color: var(--primary-color)
    +mobile
      width: 100%
      text-align: center
  .right
    flex-grow: 1
    > h1
      color: #3e3a39
      font-size: 38px
      margin-bottom: 50px
      +mobile
        display: none

.con-present-relate
  padding: 59px 0 87px 0
  background-color: #f5f7f8
  h2
    font-size: 24px
    color: #3e3a39
    text-align: center
    margin-bottom: 30px
  .present
    display: block
    height: auto
    border: 1px solid #d6dce3
    padding: 20px 15px
    background-color: #fff
    transition: all 0.25s
    &.multi
      height: auto
    &:hover
      box-shadow: 0 0 10px rgba(192, 209, 226, .8)
    > .title
      display: block
      font-size: 18px
      color: #3e3a39
      margin-bottom: 15px
    .relative-bottom
      &.multi
        .bottom
          margin-top: 10px
          &:first-child
            margin-top: 0
          img
            width: 50px
            height: 50px
          .detail
            h6
              display: inline-block
              margin-top: 5px
      .bottom
        display: flex
        align-items: center
        img
          width: 95px
          height: 95px
          border-radius: 50%
          border: 1px solid #f2f2f2
        .detail
          flex-grow: 1
          margin-left: 15px
          h4
            font-size: 18px
            color: var(--primary-color)
          h6
            font-size: 14px
            color: #8e9ca9
            margin-top: 9px
            line-height: 1.4em
          .position
            margin-top: 3px

.con-present-header
  background: url('./assets/presentation_bg.jpg') no-repeat center
  background-size: 100% 100%
  padding: 34px 25px
  position: relative
  .ppt
    position: absolute
    right: 6vw
    bottom: 30px
    width: 30px
    height: auto
  h2
    color: var(--primary-color)
    font-size: 18px
    font-weight: 900
    margin-bottom: 10px
  h3.belongsto
    display: inline-flex
    border: 1px solid var(--primary-color)
    border-radius: 4px
    padding: 0 9px
    height: 36px
    align-items: center
    font-size: 14px
    margin-bottom: 20px
    a:hover
      color: #2180C2
  .guest, .time, .location
    margin-top: 11px
    font-size: 13px
    color: #3E3A39
    width: 83%
</style>
